function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "isObject",
    value: function isObject(obj) {
      return _typeof(obj) === "object" && obj !== null;
    }
  }, {
    key: "isString",
    value: function isString(obj) {
      return typeof obj === "string";
    }
  }, {
    key: "isNumber",
    value: function isNumber(obj) {
      return typeof obj === "number" && !isNaN(obj);
    }
  }, {
    key: "isBoolean",
    value: function isBoolean(obj) {
      return typeof obj === "boolean";
    }
  }, {
    key: "isArray",
    value: function isArray(obj) {
      return this.isObject(obj) && Array.isArray(obj);
    }
  }, {
    key: "isFunction",
    value: function isFunction(obj) {
      return typeof obj === "function";
    }
  }, {
    key: "isNotNull",
    value: function isNotNull(obj) {
      return typeof obj !== "undefined" && obj !== null;
    }
  }, {
    key: "ifObject",
    value: function ifObject(obj, ifCommand, elseCommand) {
      if (this.isObject(obj)) {
        ifCommand(obj);
      } else if (elseCommand) {
        elseCommand();
      }
    }
  }, {
    key: "ifString",
    value: function ifString(obj, command) {
      if (this.isString(obj)) {
        command(obj);
      }
    }
  }, {
    key: "ifNumber",
    value: function ifNumber(obj, command) {
      if (this.isNumber(obj)) {
        command(obj);
      }
    }
  }, {
    key: "ifBoolean",
    value: function ifBoolean(obj, command) {
      if (this.isBoolean(obj)) {
        command(obj);
      }
    }
  }, {
    key: "ifArray",
    value: function ifArray(obj, command) {
      if (this.isArray(obj)) {
        command(obj);
      }
    }
  }, {
    key: "ifFunction",
    value: function ifFunction(obj, command) {
      if (this.isFunction(obj)) {
        command(obj);
      }
    }
  }, {
    key: "ifNotNull",
    value: function ifNotNull(obj, command) {
      if (this.isNotNull(obj)) {
        command(obj);
      }
    }
  }, {
    key: "floatValue",
    value: function floatValue(obj) {
      return this["float"](obj) || 0;
    }
  }, {
    key: "float",
    value: function float(obj) {
      var val = parseFloat(obj);
      return isNaN(val) ? null : val;
    }
  }]);

  return _default;
}();

export { _default as default };